import ONotificationsApi from './o-notifications-api.vue'

export default ONotificationsApi
